import Fixture from '@/models/Card/fixture';
import Player from '@/models/Card/player';

export default class Card {
  constructor({
    slug = null,
    name = null,
    pictureUrl = null,
    scarcity = null,
    position = null,
    edition = null,
    ownedFrom = null,
    totalScore = null,
    decisiveScore = null,
    allAroundScore = null,
    player = new Player(),
    fixture = null,
  } = {}) {
    this.slug = slug;
    this.name = name;
    this.pictureUrl = pictureUrl;
    this.scarcity = scarcity;
    this.position = position;
    this.edition = edition;
    this.ownedFrom = new Date(ownedFrom);
    this.totalScore = totalScore;
    this.decisiveScore = decisiveScore;
    this.allAroundScore = allAroundScore ? allAroundScore.toFixed(2) : null;
    this.player = Player.createFromObject(player);
    this.fixture = fixture ? Fixture.createFromObject(fixture) : null;
  }

  isCommon() {
    return this.scarcity === 'common';
  }

  isCustomSeries() {
    return this.scarcity === 'custom_series';
  }

  isLegend() {
    return this.edition === 'legend';
  }

  static createFromObject(data) {
    return new Card(data);
  }

  static createCollectionFromObject(data) {
    return data.map(
      (cardData) => Card.createFromObject(cardData),
    );
  }
}
